module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('span', {
    attrs: {
      "id": "top"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "perspective": "100vmin",
      "width": "100vw",
      "height": "100vh",
      "overflow-x": "hidden",
      "overflow-y": "auto",
      "position": "fixed",
      "top": "0",
      "-webkit-overflow-scrolling": "touch"
    },
    attrs: {
      "id": "frame"
    }
  }, [_c('v-toolbar', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "backdrop-filter": "blur(12px)",
      "background-color": "rgba(255, 255, 255, 0.85)",
      "z-index": "1024",
      "position": "sticky",
      "top": "0",
      "margin-bottom": "-64px"
    },
    attrs: {
      "prominent": "",
      "flat": "",
      "fixed": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": _vm.logoAlt
    },
    on: {
      "click": _vm.scrollToTop
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.headerButtons), function(i) {
    return _c('v-flex', {
      key: i.path,
      on: {
        "click": _vm.scrollToTop
      }
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [_c('v-card', {
      class: {
        transparent: true, 'header-bar-button': true, 'header-bar-button-active': _vm.selectedHeaderButton === i.text
      },
      staticStyle: {
        "padding": "8px"
      },
      attrs: {
        "flat": ""
      }
    }, [_c('span', [_vm._v(_vm._s(i.text))]), _vm._v(" "), _c('div', {
      class: _vm.colPrimary,
      style: ((_vm.selectedHeaderButton === i.text ? 'opacity: 1.0; transform: translateY(0px);' : 'opacity: 0.0; transform: translateY(5px);') + 'transition: all .3s ease; height: 3px;')
    })])], 1) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.lng.shopLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "color": "green",
      "outline": "",
      "round": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lng.openShop))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "16px"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "lang-button hidden-sm-and-down black--text",
    attrs: {
      "icon": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.focusLanguageSwitcher();
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.language) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.0))",
      "position": "sticky",
      "top": "64px",
      "height": "6px",
      "margin-bottom": "-6px",
      "width": "100%",
      "z-index": "512"
    }
  }), _vm._v(" "), _c('div', {
    ref: "lang-switcher",
    staticClass: "lang-switcher-container top",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function () {
        _vm.blurLanguageSwitcher();
      }
    }
  }, [_c('div', {
    staticClass: "lang-switcher"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _vm._l((_vm.languages), function(lang) {
    return _c('div', {
      key: lang.name
    }, [_c('div', {
      class: ['button-stripe', _vm.colPrimary, (lang.name === _vm.language) ? 'button-stripe-selected' : '']
    }), _vm._v(" "), _c('div', {
      class: ['button', 'noselect', (lang.name === _vm.language) ? 'button-selected' : ''],
      on: {
        "click": function () {
          _vm.setLanguage(lang.name, true);
          _vm.blurLanguageSwitcher();
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(lang.title) + "\n\t\t\t\t\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  })], 2)]), _vm._v(" "), _c('v-toolbar', {
    staticClass: "hidden-xs-only",
    attrs: {
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('img', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "src": _vm.logo,
      "alt": _vm.logoAlt
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.lng.shopLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "color": "green",
      "outline": "",
      "round": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lng.openShop))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "16px"
    }
  }), _vm._v(" "), _c('div', [_c('v-menu', [_c('v-btn', {
    attrs: {
      "outline": "",
      "icon": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.language))]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang) {
    return _c('span', {
      key: lang.name
    }, [(lang.name === _vm.language) ? _c('span', [_c('v-list-tile', {
      staticClass: "elevation-2",
      class: _vm.colPrimary,
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1) : _c('span', [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1)])
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "hidden-md-and-up hidden-xs-only pad-8",
    class: [_vm.colPrimary]
  }, [_c('v-spacer'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.headerButtons), function(i) {
    return _c('v-flex', {
      key: i.path,
      on: {
        "click": _vm.scrollToTop
      }
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [(_vm.selectedHeaderButton === i.text) ? _c('v-btn', {
      attrs: {
        "block": ""
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(i.text) + "\n\t\t\t\t\t\t\t")]) : _c('v-btn', {
      attrs: {
        "flat": "",
        "block": ""
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(i.text) + "\n\t\t\t\t\t\t\t")])], 1) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-up xs-toolbar-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-up xs-toolbar"
  }, [_c('div', {
    staticClass: "shadow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "8px",
      "z-index": "1025"
    }
  }, [_c('v-menu', [_c('v-btn', {
    staticStyle: {
      "text-shadow": "0 1px 2px rgba(0, 0, 0, 0.5)"
    },
    attrs: {
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.language))]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang) {
    return _c('span', {
      key: lang.name
    }, [(lang.name === _vm.language) ? _c('span', [_c('v-list-tile', {
      staticClass: "elevation-2",
      class: _vm.colPrimary,
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1) : _c('span', [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1)])
  }))], 1)], 1), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.siteName) + "\n\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    class: ['icon', 'icon-menu', _vm.drawer ? '' : 'icon-active']
  }, [_vm._v("menu")]), _vm._v(" "), _c('v-icon', {
    class: ['icon', 'icon-chev', _vm.drawer ? 'icon-active' : '']
  }, [_vm._v("chevron_left")])], 1)], 1), _vm._v(" "), _c('div', {
    class: ['hidden-sm-and-up', 'nav-drawer-container', _vm.drawer ? 'nav-drawer-container-open' : 'nav-drawer-container-closed']
  }, [_c('div', {
    staticClass: "bg",
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ['nav-drawer', _vm.drawer ? 'nav-drawer-open' : 'nav-drawer-closed']
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "24px"
    }
  }), _vm._v(" "), _vm._l((_vm.headerButtons), function(i) {
    return _c('div', {
      key: i.path,
      on: {
        "click": function () {
          _vm.scrollToTop();
          _vm.closeDelay(1);
        }
      }
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [_c('div', {
      class: ['button', _vm.selectedHeaderButton === i.text ? 'button-selected' : '']
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(i.text))])])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "32px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "block",
      "padding": "0 64px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.lng.shopLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "block": "",
      "color": "white",
      "outline": "",
      "round": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lng.openShop))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shadow"
  })], 2)]), _vm._v(" "), (_vm.showCookie) ? _c('div', {
    staticClass: "elevation-4"
  }, [_c('v-toolbar', {
    staticClass: "warning",
    attrs: {
      "flat": "",
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "long-text",
    staticStyle: {
      "opacity": "0.75"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.cookieMsg) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.lng.cookieLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "small": ""
    }
  }, [_c('div', {
    staticStyle: {
      "opacity": "0.65"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.whatAreCookies) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("help")])], 1)], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disableCookieInfo()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pageName !== '') ? _c('div', [_c('v-toolbar', {
    class: [_vm.colAccent],
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.pageName) + "\n\t\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "language": _vm.language
    }
  }), _vm._v(" "), _c('footer', [(_vm.showFooter) ? _c('v-card', {
    class: [_vm.colSecondary],
    staticStyle: {
      "padding": "24px"
    },
    attrs: {
      "dark": "",
      "tile": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "hidden-sm-and-down"
  }, _vm._l((_vm.headerButtons), function(i) {
    return _c('div', {
      key: i.path
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [_c('button', {
      staticClass: "white--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(i.text) + "\n\t\t\t\t\t\t\t\t")])]) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-flex', [_vm._v("\n\t\t\t\t\t\tHaplabit UG (haftungsbeschränkt)"), _c('br'), _vm._v("\n\t\t\t\t\t\tEchterstrasse 8a"), _c('br'), _vm._v("\n\t\t\t\t\t\tD-97209 Veitshoechheim"), _c('br'), _vm._v("\n\t\t\t\t\t\tDipl. – Ing. Harald Samoticha"), _c('br'), _vm._v("\n\t\t\t\t\t\t+49 1522 8619 710"), _c('br'), _vm._v("\n\t\t\t\t\t\tDE338177997"), _c('br')]), _vm._v(" "), _c('v-flex', [_vm._v("\n\t\t\t\t\t\t+49 1522 8619 710"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "mailto:info@hapla.eu"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tinfo@hapla.eu\n\t\t\t\t\t\t")]), _c('br')])], 1), _vm._v(" "), _c('div', [_c('v-menu', [_c('v-btn', {
    attrs: {
      "dark": "",
      "outline": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.lng.language) + ": " + _vm._s(_vm.language))]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang) {
    return _c('span', {
      key: lang.name
    }, [(lang.name === _vm.language) ? _c('span', [_c('v-list-tile', {
      staticClass: "elevation-2",
      class: _vm.colPrimary,
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1) : _c('span', [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1)])
  }))], 1)], 1)], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc05297a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 162
// module chunks = 1 2